import type { Schema } from '@dealdesk/api-schema';

import { api, unwrap } from '@/shared/api/client';

export function savePreferences(body: Schema<'Preferences'>) {
  return unwrap(api.PATCH('/me/preferences', { body }));
}
